<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import Modal from '@components/Modal.svelte';

  import '@simonwep/pickr/dist/themes/nano.min.css';
  let FontPicker;

  onMount(async () => {
    FontPicker = (await import('font-picker')).default;
  });

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let style = '';
  export let cssConfiguration = {};
  export let fontCategories;

  export let fontFamilyLabel = 'Font family';
  export let fontColorLabel = 'Font color';
  export let fontWeightLabel = 'Font weight';
  export let fontSizeLabel = 'Font size';

  export let showFontFamily = true;
  export let showFontColor = true;
  export let showFontWeight = true;
  export let showFontSize = true;

  export let fontFamilyAttr = 'font-family';
  export let fontColorAttr = 'color';
  export let fontWeightAttr = 'font-weight';
  export let fontSizeAttr = 'font-size';

  export let fontSizes = [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26];

  let fontPicker;
  let colorPicker;

  let fontPickerId = Math.random().toString(36).substr(2, 9);

  let close = function () {
    showModal = false;
    fontPicker = undefined;
    colorPicker = undefined;

    dispatch('close');
  };

  let setupFontSelector = function () {
    if (fontPicker) {
      return;
    }

    let data = {
      pickerId: fontPickerId,
      limit: 100,
    };

    if (fontCategories) {
      data['categories'] = fontCategories;
    }

    fontPicker = new FontPicker(
      'AIzaSyCk0OdjV2PRoiZ40qXdC8pfb7Ex1AgIY6E',
      cssConfiguration[fontFamilyAttr],
      data,
      function (data) {
        cssChange(fontFamilyAttr, data.family);
      }
    );

    setTimeout(function () {
      // might be removed by now
      if (fontPicker && !fontPicker.getFonts().has('Helvetica Neue')) {
        fontPicker.addFont('Helvetica Neue', 37);
      }
    }, 500);

    return {
      destroy() {
        fontPicker = undefined;
      },
    };
  };

  let setupColorPicker = async function (node) {
    if (colorPicker) {
      return;
    }

    const PickrModule = await import('@simonwep/pickr');
    const Pickr = PickrModule.default;

    colorPicker = new Pickr({
      el: node,
      theme: 'nano',
      useAsButton: false,
      default: cssConfiguration[fontColorAttr],
      defaultRepresentation: 'HEX',
      components: {
        preview: true,
        hue: true,
      },
    });

    colorPicker.on('change', (color, _source, _instance) => {
      let hex = color.toHEXA().toString();
      cssChange(fontColorAttr, hex);
      colorPicker.setColor(hex);
    });

    return {
      destroy() {
        if (colorPicker) {
          colorPicker.destroyAndRemove();
          colorPicker = undefined;
        }
      },
    };
  };

  let cssChange = function (prop, value) {
    cssConfiguration[prop] = value;
    dispatch('change');
  };
</script>

<style style="text/scss" lang="scss">
  * :global(.pickr) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    overflow: hidden;
    height: 55px;
    border: 2px solid #ececec;
    border-right: none;
  }

  * :global(.pcr-button) {
    height: 55px;
    width: 50px;
  }

  :global(.pcr-color-chooser) {
    height: 25px !important;
  }

  :global(.pcr-slider) {
    border-radius: 8px !important;
    margin-bottom: -8px !important;
  }

  .select-control {
    outline: none;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
    border-radius: 12px;
    border: 2px solid #ececec;
    padding-left: 21px;
    padding-right: 21px;
    padding-top: 15px;
    padding-bottom: 15px;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    color: #495057;
    width: 100%;
  }

  .svelte-design-palette-modal {
    left: calc(50% + 320px) !important;
    outline: none !important;
    justify-content: left !important;
    overflow: hidden !important;
    display: flex !important;
  }

  .svelte-design-palette-modal :global(.modal__overlay) {
    background: transparent !important;
  }

  .svelte-design-palette-modal :global(.modal__content) {
    margin-top: 0px !important;
    margin-bottom: -15px !important;
  }
</style>

{#if FontPicker}
  <div class="svelte-design-palette-modal">
    <Modal
      mobile={mobile}
      on:close={close}
      show={showModal}
      showCloseButton={false}
      fadeInDuration={200}
      style="border-radius: 24px; width: 330px; {style}">
      <div slot="content">
        <div style="display: flex; flex-direction: column;">
          {#if showFontFamily}
            <div>
              <div
                style="margin-bottom: 10px; font-size: 13px; line-height: 14px;
            opacity: 0.5;">
                {fontFamilyLabel}
              </div>
              <div>
                <div
                  style="width: 100%; outline: none; border-radius: 12px;
              box-shadow: unset;"
                  class="font-picker"
                  use:setupFontSelector
                  id={`font-picker-${fontPickerId}`} />
              </div>
            </div>
          {/if}

          {#if showFontColor}
            <div style="margin-top: 20px">
              <div
                style="margin-bottom: 10px; font-size: 13px; line-height: 14px;
            opacity: 0.5;">
                {fontColorLabel}
              </div>
              <div style="display: flex">
                <div use:setupColorPicker />
                <input
                  style="width: 100%; outline: none; transition: border-color 0.15s
              ease-in-out, box-shadow 0.15s ease-in-out; border-top-right-radius: 12px; border-bottom-right-radius: 12px;
              border: 2px solid #ececec; font-size: 14px; padding-top: 15px;
              padding-bottom: 15px; padding-left: 15px; border-left: 1px solid #aaa;"
                  on:focus={() => {
                    if (colorPicker) {
                      colorPicker.show();
                    }
                  }}
                  on:blur={() => {
                    if (colorPicker) {
                      colorPicker.hide();
                    }
                  }}
                  on:change={(e) => {
                    cssChange(fontColorAttr, e.target.value, e);

                    if (colorPicker) {
                      colorPicker.setColor(e.target.value);
                    }
                  }}
                  value={cssConfiguration[fontColorAttr]} />
              </div>
            </div>
          {/if}

          <div style="margin-top: 20px; display: flex">
            {#if showFontWeight}
              <div style="margin-right: 8px; flex: 1;">
                <div
                  style="margin-bottom: 10px; font-size: 13px; line-height: 14px;
              opacity: 0.5;">
                  {fontWeightLabel}
                </div>
                <div>
                  <select
                    on:change={(e) => {
                      cssChange(fontWeightAttr, e.target.value, e);
                    }}
                    class="select-control"
                    value={cssConfiguration[fontWeightAttr]}>
                    <option value="normal">Regular</option>
                    <option value="bold">Bold</option>
                  </select>
                </div>
              </div>
            {/if}
            {#if showFontSize}
              <div style="margin-left: 8px; flex-shrink: 0">
                <div
                  style="margin-bottom: 10px; font-size: 13px; line-height: 14px;
              opacity: 0.5;">
                  {fontSizeLabel}
                </div>
                <div>
                  <select
                    on:change={(e) => {
                      cssChange(fontSizeAttr, e.target.value, e);
                    }}
                    class="select-control"
                    value={cssConfiguration[fontSizeAttr]}>
                    {#each fontSizes as size}
                      <option value="{size}px">{size} px</option>
                    {/each}
                  </select>
                </div>
              </div>
            {/if}
          </div>
        </div>
      </div>
    </Modal>
  </div>
{/if}
